import { Box } from 'libs/ui';
import { CSSObject, styled } from 'libs/ui/styled';

export const ContentStyled = styled(Box)(() => ({
  display: 'flex',
  gap: 12,
  flexWrap: 'wrap',

  '.directory-item': {
    width: 'calc(50% - 6px)',
  } as CSSObject,
}));
